function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0601 14.1241L28.6232 25.6873L40.1864 14.1241M17.0601 30.3126L28.6232 41.8758L40.1864 30.3126",
  stroke: "#FF0000",
  strokeWidth: 4.62527,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgDoubleChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleChevronDown);
export default __webpack_public_path__ + "static/media/double-chevron-down.5323be21.svg";
export { ForwardRef as ReactComponent };